export const extractConfigDefinitionTypesMap = (configDefinition) =>
  Object.fromEntries(
    Object.entries(configDefinition?.properties || {}).map(([key, value]) => [key, value.type])
  );

export const extractConfigDefinitionSubTypesMap = (configDefinition) =>
  Object.fromEntries(
    Object.entries(configDefinition?.properties || {})
      .filter(([, value]) => value?.subType !== undefined)
      .map(([key, value]) => [key, value.subType])
  );

export const parseConfig = async (config, configDefTypesMap) => {
  const parsedConfig = _.reduce(config, (acc, val, key) => {
    if (val !== undefined) {
      acc[key] = configDefTypesMap[key]?.type === 'object' && typeof val !== 'object'
        ? JSON.parse(val)
        : val;
    }
    return acc;
  }, {});

  if (parsedConfig.file instanceof Weaver.File) {
    const uploadedFile = await parsedConfig.file.upload();
    return { ...parsedConfig, file: uploadedFile.id() };
  }

  return parsedConfig;
};

export const cleanUpNewTask = ({ config = {}, name, functionalityName, functionalityVersion, branch }) => ({
  userId: Weaver.getInstance().currentUser().id(),
  branch,
  functionalityName,
  functionalityVersion,
  name,
  config
});

export const cleanUpEditedTask = ({ scheduleUid, config = {} }) => ({
  user: Weaver.getInstance().currentUser().id(),
  scheduleUid,
  config
});
